import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { listAudiences } from '~/services/PromoService';

import { audienceQueryKeys } from './audienceQueryKeys';

type Params = {
  query: Parameters<typeof listAudiences>[0];
  enabled?: boolean;
};

export function useListAudiences({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: audienceQueryKeys.list(query),
    queryFn: async ({ signal }) => listAudiences(query, { signal }),
    enabled,
    placeholderData: keepPreviousData,
  });
}
